import React from 'react'
import PropTypes from 'prop-types'
import appConfig from '../../appConfig'

const DEFAULT_CALENDAR_CONFIG = {
  title: 'BTA Event Calendar',
  subTitle: '',
  maxNumberOfEvents: 20,
  monthsIntoTheFuture: 6,
}

const { Provider, Consumer } = React.createContext(DEFAULT_CALENDAR_CONFIG)

const ConfigProvider = ({ children }) => (
  <Provider value={appConfig}>{children}</Provider>
)

ConfigProvider.propTypes = {
  children: PropTypes.node,
}

const CalendarConfigContext = {
  Provider: ConfigProvider,
  Consumer,
}

export default CalendarConfigContext
